// Per-run candidate grant, client side (editable-plan spec 0.3). A generation submit can
// report what it asked for (`requested`) and what the plan's per-run limit let it run
// (`granted`), in the service's charge unit: MatterGen candidates (batch_size x
// num_batches), GT4SD n_samples, FM4M num_samples x oversample (R4-2). Our services return
// both in the submit JSON. llm-proxy tallies BYOC relay and remote-endpoint submits itself
// and forwards the downstream body as-is, so it reports them as X-Spectra-Requested /
// X-Spectra-Granted response headers. Pure, no imports.

function toCount(value) {
  if (value === null || value === undefined || value === '') return undefined;
  const n = Number(value);
  return Number.isInteger(n) && n >= 0 ? n : undefined;
}

function headerValue(resp, name) {
  const headers = resp && resp.headers;
  return headers && typeof headers.get === 'function' ? headers.get(name) : null;
}

/**
 * The grant a submit response reports, as { requested?, granted? } with only the keys it
 * found. The proxy's headers win over the body: when the proxy tallied, it saw the original
 * request, while the body comes from a downstream that only saw the granted one.
 */
export function readSubmitGrant(resp, json) {
  const body = json && typeof json === 'object' ? json : {};
  const requested = toCount(headerValue(resp, 'X-Spectra-Requested')) ?? toCount(body.requested);
  const granted = toCount(headerValue(resp, 'X-Spectra-Granted')) ?? toCount(body.granted);
  const out = {};
  if (requested !== undefined) out.requested = requested;
  if (granted !== undefined) out.granted = granted;
  return out;
}

/**
 * Sum the grants of several jobs or run rows: { requested, granted } over the items that
 * report `granted` (an item without `requested` counts as granted in full), or {} when none
 * does. A row is capped when the sum's granted is below its requested.
 */
export function sumGrants(items) {
  let requested = 0;
  let granted = 0;
  let seen = false;
  for (const item of Array.isArray(items) ? items : []) {
    const g = toCount(item && item.granted);
    if (g === undefined) continue;
    const q = toCount(item.requested);
    seen = true;
    granted += g;
    requested += q === undefined ? g : q;
  }
  return seen ? { requested, granted } : {};
}
